export class IdViewModel {
    ids: number[];
    cols: string;
    shipmentId?: any;
    selectedDistrictIds: number[]
}